import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';

export default function MenuButton({ name, clazzName, buttons, icon, onOpen = () => {}, onClose = () => {} }) {
  const StyledMenuItem = styled(MenuItem)(() => ({
    '&.Mui-disabled': {
      opacity: 1,
    },
    '& .MuiSvgIcon-root': {
      color: '#000000',
    },
  }));

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (typeof onOpen === 'function') {
      onOpen();
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <div>
      <Button
        id={`qa-${clazzName}-button`}
        aria-controls={anchorEl ? `qa-${clazzName}` : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        style={{ border: 'solid 1px', textTransform: 'none', fontSize: '14px' }}
      >
        <span style={{ marginRight: '7px', marginTop: '7px' }}>{icon}</span>
        {name}
      </Button>
      <Menu
        id={`qa-${clazzName}`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `qa-${clazzName}-button`,
        }}
      >
        {buttons.map(({ label, onClick, id, disabled, icon }, i) => {
          return (
            <StyledMenuItem
              className={`qa-${clazzName}-item-${i} qa-list-${i}`}
              key={i}
              id={id}
              onClick={(evt) => {
                setAnchorEl(null);
                onClick(evt);
              }}
              disabled={disabled}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText>{label}</ListItemText>
            </StyledMenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
